import { apiFetch, v1Path } from './api';
import { isStateDto, parseItems, type StateDto } from './work-types';

export async function fetchStatesByProjectIds(projectIds: string[]): Promise<{
  byId: Map<string, StateDto>;
  byProject: Map<string, StateDto[]>;
}> {
  const unique = Array.from(new Set(projectIds));
  const byId = new Map<string, StateDto>();
  const byProject = new Map<string, StateDto[]>();
  if (unique.length === 0) return { byId, byProject };

  const lists = await Promise.all(
    unique.map((projectId) => apiFetch<unknown>(v1Path(`/projects/${projectId}/states`))),
  );

  unique.forEach((projectId, index) => {
    const payload = lists[index];
    if (payload === undefined) {
      throw new Error(`Missing states response for project ${projectId}.`);
    }
    const states = parseItems(payload, isStateDto, 'states');
    byProject.set(projectId, states);
    for (const state of states) {
      byId.set(state.id, state);
    }
  });

  return { byId, byProject };
}
